import styled from 'styled-components';

import { getNonStickyTop } from '@marriott/mi-store-utils';
import { toRem, baseVariables } from '@marriott/mi-ui-library';

type StickyProps = {
  $isSticky: boolean;
  $top: number;
  $isNorthStar?: boolean;
  $hasGlobalNav?: boolean;
  $offset: number;
};

type BreakpointTopArgs = Pick<StickyProps, '$isSticky' | '$top' | '$isNorthStar' | '$hasGlobalNav'>;

/** Resolves the CSS `top` value for the `xs` breakpoint, appending `--tab-title-wrap-offset` on NorthStar to shift the SearchForm down when the page title wraps onto a second line. */
function resolveXsTopOffset(
  { $isSticky, $top, $isNorthStar, $hasGlobalNav }: BreakpointTopArgs,
  wrapOffsetDefault: string
) {
  if ($isSticky) return toRem($top);

  const baseTopOffset = toRem(getNonStickyTop('xs', $isNorthStar, $hasGlobalNav));
  if ($isNorthStar) return `calc(${baseTopOffset} + var(--tab-title-wrap-offset, ${wrapOffsetDefault}))`;
  return baseTopOffset;
}

export const StyledStickyComponentWrapper = styled.div<StickyProps>`
  width: ${({ $isSticky }) => ($isSticky ? '100vw' : '100%')};
  max-width: 100%;
  position: ${({ $isSticky }) => ($isSticky ? 'fixed' : 'relative')};
  ${({ $isSticky }) => ($isSticky ? 'left: 0; right: 0; z-index: 50;' : '')}
  ${({ $isSticky, $top }) => ($isSticky && $top !== 0 ? 'transition: top 0.4s ease 0s;' : '')}
  top: ${props => resolveXsTopOffset(props, '36px')};
  @media (min-width: 368px) {
    top: ${props => resolveXsTopOffset(props, '0px')};
  }
  @media ${baseVariables.mediaQuery.sm} {
    top: ${({ $isSticky, $top, $isNorthStar, $hasGlobalNav }) =>
      $isSticky ? toRem($top) : toRem(getNonStickyTop('sm', $isNorthStar, $hasGlobalNav))};
  }
  @media ${baseVariables.mediaQuery.md} {
    top: ${({ $isSticky, $top, $isNorthStar, $hasGlobalNav }) =>
      $isSticky ? toRem($top) : toRem(getNonStickyTop('md', $isNorthStar, $hasGlobalNav))};
  }
  @media ${baseVariables.mediaQuery.lg} {
    top: ${({ $isSticky, $top, $isNorthStar, $hasGlobalNav }) =>
      $isSticky ? toRem($top) : toRem(getNonStickyTop('lg', $isNorthStar, $hasGlobalNav))};
  }

  .search-form-position {
    width: 100vw !important;
  }
`;
